import { _ } from "i18n";
import type { EventListTeamInfo, MergedGpEventResponse } from "../../../types";
import type { MediaPlayerInstance } from "@vidstack/react";
import "./clips.css";
import { EventListContainer } from "../EventList/EventListContainer";

interface ClipEventsProps {
	setShowSidebar: (show: boolean) => void;
	currentTime: number;
	mergedEvents: MergedGpEventResponse[];
	playerRef: React.RefObject<MediaPlayerInstance>;
	teamInfo: EventListTeamInfo;
	eventCount: number;
}

export function ClipEvents({ setShowSidebar, currentTime, mergedEvents, playerRef, teamInfo, eventCount }: ClipEventsProps) {
	return (
		<div className="clipEvents-container">
			<div className="clipEvents-header">
				<div className="headerText">{_("gamePage.label.eventList")}</div>
				<div className="header-controls">
					<span className="icon-new icon-light-cross icon-14" onClick={() => setShowSidebar(false)} />
				</div>
			</div>
			<EventListContainer
				currentTime={currentTime}
				eventCount={eventCount}
				teamInfo={teamInfo}
				isClip
				mergedEvents={mergedEvents}
				playerRef={playerRef}
				eventCommentsPermission={false}
			/>
		</div>
	);
}
